import api, { APIURL, errorHandle, authenHeader, formDataHeader } from '../api/api'

class FormRequest {

    static DEFAULT_FORM_VALUE = {
        level: null,
        office: null,
        requester_first_name: "", // title + first_name
        requester_last_name: "",
        requester_position_name: "",
        tel: "",
        marital_status: null,
        spouse_full_name: "",
        spouse_position_name: "",
        spouse_office_name: "",
        children: 0,
        address: "",
        soi: "",
        subdistrict: null,
        district: null,
        province: null,
        house_owner: null,
        house_status: null,
        house_other_status_name: "",
        residence: null,
        head_full_name: "",
        head_position_name: "",
        scan_document_list: ['1','2'],
        other_document_name: ""
    }

    constructor(obj) {

        this.requester_first_name = obj.requester_first_name
        this.requester_last_name = obj.requester_last_name
        this.requester_position_name = obj.requester_position_name
        this.tel = obj.tel
        this.spouse_full_name = obj.spouse_full_name
        this.spouse_position_name = obj.spouse_position_name
        this.spouse_office_name = obj.spouse_office_name
        this.children = obj.children
        this.address = obj.address
        this.soi = obj.soi
        this.house_other_status_name = obj.house_other_status_name
        this.head_full_name = obj.head_full_name
        this.head_position_name = obj.head_position_name
        this.other_document_name = obj.other_document_name

        this.district = obj.district
        this.province = obj.province
        this.subdistrict = obj.subdistrict

        // create new form
        if (obj.scan_document_list) {
            this.scan_document_list = obj.scan_document_list?.map(i => parseInt(i))
            this.residence = obj.residence
            this.house_owner = obj.house_owner
            this.house_status = obj.house_status
            this.marital_status = obj.marital_status
            this.level = obj.level
            this.office = obj.office
        }

        // full properties
        if (obj.id) {
            this.id = obj.id
            this.approve_date = obj.approve_date
            this.approve_note = obj.approve_note
            this.approve_result = obj.approve_result
            this.approver_name = obj.approver_name
            this.approver_uid = obj.approver_uid
            this.file_path = obj.file_path
            this.file_path_url = obj.file_path_url
            this.form_date = obj.form_date
            this.form_local = obj.form_local
            this.form_status_id = obj.form_status_id
            this.form_status_name = obj.form_status_name
            this.house_owner_id = obj.house_owner_id
            this.house_owner_name = obj.house_owner_name
            this.house_status_id = obj.house_status_id
            this.house_status_name = obj.house_status_name
            this.level_id = obj.level_id
            this.level_name = obj.level_name
            this.marital_status_id = obj.marital_status_id
            this.marital_status_name = obj.marital_status_name
            this.office_code = obj.office_code
            this.office_name = obj.office_name
            this.owner_name = obj.owner_name
            this.owner_uid = obj.owner_uid
            this.residence_id = obj.residence_id
            this.residence_name = obj.residence_name
            this.submit_date = obj.submit_date
            this.form_request_scan_document = obj.form_request_scan_document
        }
    }

    serialized() {
        return {
            "form_local": this.office.label,
            "requester_first_name": this.requester_first_name,
            "requester_last_name": this.requester_last_name,
            "requester_position_name": this.requester_position_name,
            "level_id": parseInt(this.level?.value || this.level_id),
            "office_code": this.office.value,
            "tel": this.tel,
            "marital_status_id": parseInt(this.marital_status?.value || this.marital_status_id),
            "spouse_full_name": this.spouse_full_name || "",
            "spouse_position_name": this.spouse_position_name || "",
            "sponse_office_name": this.spouse_position_name || "",
            "children": parseInt(this.children),
            "address": this.address,
            "soi": this.soi,
            "subdistrict": this.subdistrict?.label || this.subdistrict,
            "district": this.district?.label || this.district,
            "province": this.province?.label || this.province,
            "house_owner_id": parseInt(this.house_owner?.value || this.house_owner_id),
            "house_status_id": parseInt(this.house_status?.value || this.house_status_id),
            "house_other_status_name": this.house_other_status_name || "",
            "residence_id": parseInt(this.residence?.value || this.residence_id),
            "head_full_name": this.head_full_name,
            "head_position_name": this.head_position_name,
            "scan_document_list": this.scan_document_list || [],
            "other_document_name": this.other_document_name
        }
    }

    formValue() {
        return {
            ...this,
            scan_document_list: this.form_request_scan_document?.map(i => i.scan_document_id + ""),
            residence: { value: this.residence_id, label: this.residence_name },
            house_owner: { value: this.house_owner_id, label: this.house_owner_name },
            house_status: { value: this.house_status_id, label: this.house_status_name },
            marital_status: { value: this.marital_status_id, label: this.marital_status_name },
            level: { value: this.level_id, label: this.level_name },
            office: { value: this.office_code, label: this.office_name },
            district: { label: this.district, value: 0 },
            province: { label: this.province, value: 0 },
            subdistrict: { label: this.subdistrict, value: 0 }
        }
    }

}

export const postFormRequest = async (data, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.post(APIURL.FORM_REQUEST(), data, headers)
            .then(res => {
                if (res.data.data) {
                    const formData = new FormRequest(res.data.data)
                    resolve(formData)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })

    })
}

export const uploadFile = async (fid, data, token) => {
    const headers = {
        headers: { ...authenHeader(token), ...formDataHeader }
    }

    return new Promise((resolve, reject) => {
        api.patch(APIURL.FORM_REQUEST(`${fid}/file`), data, headers)
            .then(res => {
                if (res.data.data) {
                    const formData = new FormRequest(res.data.data)
                    resolve(formData)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })

    })
}

export const getFormRequestInfo = async (fid, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.get(APIURL.FORM_REQUEST(fid), headers)
            .then(res => {
                if (res.data.data) {
                    const formData = new FormRequest(res.data.data)
                    resolve(formData)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const getFormRequests = async (ownerUID, token, otherQuery) => {
    const headers = {
        headers: authenHeader(token)
    }
    let query = `?owner_uid=${ownerUID}` || ''
    if (otherQuery) {
        query = query ? `${query}&${otherQuery}` : otherQuery
    }
    return new Promise((resolve, reject) => {
        api.get(APIURL.FORM_REQUEST(query), headers)
            .then(res => {
                if (res.data.data) {
                    // const formData = new FormRequest(res.data.data)
                    const listData = res.data.data.map(item => new FormRequest(item))
                    resolve(listData)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const getFormRequestFileUrl = async (fid, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.get(APIURL.FORM_REQUEST(`${fid}/printing`), headers)
            .then(res => {
                if (res.data.data) {
                    resolve(res.data.data)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })

    })
}

export const patchUpdateFormRequest = async (fid, action, token, data = {}) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.patch(APIURL.FORM_REQUEST(`${fid}/${action}`), data, headers)
            .then(res => {
                if (res.data.data) {
                    resolve(res.data.data)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })

    })
}

export const putUpdateFormRequest = async (fid, data, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.put(APIURL.FORM_REQUEST(`${fid}`), data, headers)
            .then(res => {
                if (res.data.data) {
                    resolve(res.data.data)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })

    })
}

export const deleteFormRequest = async (fid, token) => {
    const headers = {
        headers: authenHeader(token)
    }

    return new Promise((resolve, reject) => {
        api.delete(APIURL.FORM_REQUEST(`${fid}`), headers)
            .then(res => {
                if (res.data.data) {
                    resolve(res.data.data)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })

    })
}

export default FormRequest